module.exports = __webpack_public_path__ + "static/media/ding_cropped.d1944a0f.mp3";